import textareaGenerator from './TextareaGenerator';

export default textareaGenerator('textarea');
